import { render, staticRenderFns } from "./NavigateBack.vue?vue&type=template&id=ee3357f8&"
import script from "./NavigateBack.vue?vue&type=script&lang=ts&"
export * from "./NavigateBack.vue?vue&type=script&lang=ts&"
import style0 from "./NavigateBack.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports